import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { IWizItemRenderer, WizCheckbox, WizEventManager} from '@wizeoo/akm-component-lib';

import { ALK_EVENT_TYPE, WIDGET_GLOBAL_KIND } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { Color, colorSets } from '../../../ngx-charts/utils/color-sets';
import { ViewData } from '../../../../model/view.data';
import { StyleEngine, styleTrio } from '../../../../manager/workingdata/style.engine';
import { IWidgetFilter } from '../../../../manager/widgets/i-widget';

/**
 * rendu d'un filtre de pivot
 */
@Component({
  selector: 'timeline-field-renderer',
  templateUrl: './timeline-field.renderer.html',
})
export class TimelineFieldRenderer implements AfterViewInit, IWizItemRenderer<null, IWidgetFilter> {
  @HostBinding('style.width') elwidth: string = '100%';
  @HostBinding('style.height') elheight: string = '30px';
  @ViewChild('cbx', { read: WizCheckbox }) cbx: WizCheckbox;
  @ViewChild('blockFont') blockFont: ElementRef; // zone de dessin de la couleur de font

  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  // styles de headers
  public backgroundColor = StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color

  public scheme: Color = colorSets[ViewData.DEFAULT_COLOR_SET]; // jeu de couleur


  owner: null;
  private _data: IWidgetFilter; 
  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: IWidgetFilter) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get data(): IWidgetFilter {
    return this._data;
  }

/** retourne le label */
  public get labelOrDefaultLabel(): string {
    let result:string = '';
 
    if (!!this.data.wcio.lbl) {
      result = this.data.wcio.lbl;
    } else {
      if(this.data.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) {
        result = this.data.widget.model.feiEngine.getFeiKeyDefLabel(this.data.fkd);
      } else if(this.data.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) {
        return this.data.arg.trsLabel; // ou label du champ
      }
      
    }
    return result;
    // return this.fullCode; // + ' - ' + this.aggOrDefaultFunc();
  }

  ngAfterViewInit() {
    // console.log('filter', this.data.code, this.data.label);
    
    this.cbx.wizLabel = this.labelOrDefaultLabel;
    this.cbx.wizChecked = !this.data.wcio.ro;

    const domLen: number = this.scheme.domain.length; // prise du pool de couleurs
    let backgroundColor: string = this.scheme.domain[this.data.wcio.ord % domLen];
    // console.log('filter', backgroundColor, this.data.wcio.ord, this.data.label);
    if (!!this.data.wcio.hsty) {

      let res: styleTrio = this.data.widget.model.styleEngine.colorSet(this.data.wcio.hsty, 
        this.scheme.domain[this.data.wcio.ord % domLen], this.scheme.domain[this.data.wcio.ord % domLen], false);

      backgroundColor = res.backgroundColor;

      // const cleanStr = this.data.wcio.hsty.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); // (ViewData.CONTEXT_SEPARATOR, '');
      // backgroundColor = cleanStr.split(ViewData.KEY_SEPARATOR)[0];
      // if (!backgroundColor) {
      //   backgroundColor = this.scheme.domain[this.data.wcio.ord % domLen];
      // }
    }

    if (!!this.data.wcio.csty) {
            let res: styleTrio = this.data.widget.model.styleEngine.colorSet(this.data.wcio.csty, 
        this.scheme.domain[this.data.wcio.ord % domLen], this.scheme.domain[this.data.wcio.ord % domLen], false);

      backgroundColor = res.backgroundColor;   
       // const cleanStr = this.data.wcio.csty.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); // (ViewData.CONTEXT_SEPARATOR, '');
      // backgroundColor = cleanStr.split(ViewData.KEY_SEPARATOR)[0];
      // if (!backgroundColor) {
      //   backgroundColor = this.scheme.domain[this.data.wcio.ord % domLen];
      // }
    }

    this.backgroundColor = backgroundColor;

  }

  public selectField(e: Event): void {
    // console.log('sel', e);
    this.data.wcio.ro = !this.cbx.wizChecked;
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.TIMELINE_SELECT_FIELD, this.data));
  } 

}